export enum AiAgentModeEnum {
  aissitant = 0,
  aiBot = 1,
}
